// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3JABk","rootSuccess":"CompleteLink_rootSuccess__P8LC1","rootFailure":"CompleteLink_rootFailure__2zHcd","isDisabled":"CompleteLink_isDisabled__2l3HA"};